<template>
  <layout name="BaseLayout">
    <div>
      <v-toolbar text color="white">
        <v-toolbar-title>Listados</v-toolbar-title>
      </v-toolbar>

      <v-card tile outlined>
        <v-container>
          <v-form ref="form" v-model="formValid" @submit.prevent="onSubmit($event)">
            <v-card-text>
              <v-row>
                <v-col cols="3" v-if="userRoles !== undefined &&
                  locationFilterAllowedRoles.includes(userRoles[0])
                  ">
                  <v-select :items="localizacionesComputed" label="Localización*" v-model="localizacion"
                    item-text="nombre" item-value="nombre" :no-data-text="selectNoDataText" return-object
                    @change="onChange" :rules="localizacionRules" />
                </v-col>

                <v-col cols="6">
                  <v-select :items="tiposComputed" label="Tipo de listado*" v-model="tipo" item-text="nombre"
                    item-value="id" :no-data-text="selectNoDataText" return-object @change="onChange"
                    :rules="tipoRules"></v-select>
                </v-col>
              </v-row>

              <template v-if="localizacion != null && tipo != null && tipo.id == 1">
                <v-row>
                  <v-col cols="12" class="pt-0 pb-0">
                    <v-checkbox v-model="soloAlumnosNuevos" label="Solo alumnos nuevos"></v-checkbox>
                  </v-col>
                </v-row>
              </template>

              <template v-if="localizacion != null && tipo != null && tipo.id == 5">
                <v-row>
                  <v-col class="pt-0 pb-0" cols="12">
                    <v-radio-group label="Ordenar por:" v-model="sorteoOrderOption" row :mandatory="false">
                      <v-radio label="Nombre" value="nombre"></v-radio>
                      <v-radio label="Fecha" value="horaMatriculacion"></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
              </template>

              <template v-if="localizacion != null && tipo != null && tipo.id == 6">
                <v-row>
                  <v-col class="pt-0 pb-0" cols="12">
                    <v-radio-group label="De:" v-model="carnetsDe" row :mandatory="false" @change="carnetsDeChange">
                      <v-radio label="Alumnos nuevos" value="alumnos"></v-radio>
                      <v-radio label="Grupo" value="grupo"></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
              </template>

              <template v-if="localizacion != null &&
                tipo != null &&
                (tipo.id == 7 || (tipo.id == 6 && carnetsDe == 'grupo'))
                ">
                <v-row>
                  <v-col class="pt-0 pb-0" cols="6">
                    <v-select class="pt-0 pb-0" :items="idiomas" item-text="nombre" item-value="nombre" label="Idioma"
                      v-model="grupoIdioma" clearable @change="cargarNiveles" :no-data-text="selectNoDataText"
                      :rules="grupoIdiomaRules"></v-select>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col class="pt-0 pb-0" cols="6">
                    <v-select class="pt-0 pb-0" :items="grupoNiveles" label="Nivel" v-model="grupoNivel" clearable
                      item-text="descripcion" item-value="descripcion" :no-data-text="selectNoDataText"
                      :disabled="!grupoIdioma" @change="cargarGrupos()" :rules="grupoNivelRules" :loading="loadingNiveles"
                      return-object></v-select>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col class="pt-0 pb-0" cols="6">
                    <v-select class="pa-0 ma-0" :items="grupoGrupos" v-model="grupoGrupo" item-text="text"
                      item-value="value" no-data-text="No hay opciones disponibles" return-object clearable
                      :disabled="!grupoIdioma || !grupoNivel" label="Grupo" :rules="grupoGrupoRules"
                      :loading="loadingGrupos"></v-select>
                  </v-col>
                </v-row>
              </template>

              <template v-if="localizacion != null &&
                tipo != null &&
                (tipo.id == 7 || tipo.id == 8)
                ">
                <v-row>
                  <v-col cols="12" class="pt-0 pb-0">
                    <v-checkbox v-model="grupoConNotas" label="Con notas"></v-checkbox>
                  </v-col>
                </v-row>
              </template>

              <template v-if="localizacion != null && tipo != null && tipo.id == 8">
                <v-row>
                  <v-col cols="12" class="pt-0 pb-0">
                    <v-radio-group label="Ordenar por:" v-model="grupoOrderOption" row :mandatory="false">
                      <v-radio label="Aula" value="aula"></v-radio>
                      <v-radio label="Nivel" value="nivel"></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
              </template>

              <template v-if="localizacion != null && tipo != null && tipo.id == 11">
                <v-row>
                  <v-col class="pt-0 pb-0" cols="3">
                    <v-text-field v-model="remesa" label="Id remesa" required></v-text-field>
                  </v-col>
                </v-row>
              </template>

              <template v-if="localizacion != null && tipo != null && tipo.id == 12">
                <v-row>
                  <v-col class="pt-0 pb-0" cols="12">
                    <v-radio-group v-model="tipoPago" row :mandatory="true">
                      <v-radio label="Todos" value="0" selected="selected"></v-radio>
                      <v-radio label="No fraccionados" value="1"></v-radio>
                      <v-radio label="Fraccionados" value="2"></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
              </template>

              <template v-if="localizacion != null && tipo != null && tipo.id == 13">
                <v-row>
                  <v-col class="pt-0 pb-0" cols="12">
                    <v-radio-group v-model="porWeb" row :mandatory="true">
                      <v-radio label="Todos" value="0" selected="selected"></v-radio>
                      <v-radio label="Por Web" value="1"></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
              </template>
            </v-card-text>

            <v-card-actions>
              <v-btn type="submit" color="primary" :loading="loading" text :disabled="!formValid">
                Descargar
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-container>
      </v-card>
    </div>
  </layout>
</template>

<script>
import Layout from "@/components/layouts/Layout";
import { getAll, getListado } from "@/api/tiposPdf.api";
import { mapGetters } from "vuex";
import { getIdiomas } from "@/api/idiomas.api";
import { getAllNiveles } from "@/api/niveles.api";
import { getByCurso } from "@/api/grupos.api";

export default {
  name: "Listados",

  components: {
    Layout,
  },

  data: () => ({
    tipos: [],
    disabledTipos: [],
    localizacion: null,
    tipo: null,
    queryOptions: {},
    formValid: true,
    loading: false,
    selectNoDataText: "No hay opciones disponibles",

    // opciones listado sorteo
    sorteoOrderOption: "nombre",

    // opciones listado de alumnos de un grupo en concreto
    grupoIdioma: null,
    grupoNiveles: [],
    grupoNivel: null,
    grupoGrupos: [],
    grupoGrupo: null,
    grupoConNotas: false,
    grupoOrderOption: "nivel",

    // opciones listado carnets
    carnetsDe: "alumnos",

    // opciones listado alumnos
    soloAlumnosNuevos: false,

    // opcion listado alumnos por remesa
    remesa: null,

    // opcion listado tipo de pago
    tipoPago: 0,

    // opcion listado pago por tarjeta
    porWeb: 0,

    // valores para los diferentes filtros
    idiomas: [],
    allNiveles: [],
    allGrupos: [],
    loadingNiveles: false,
    loadingGrupos: false,

    // reglas validacion
    localizacionRules: [(v) => !!v || "Selecciona una opción"],
    tipoRules: [(v) => !!v || "Selecciona una opción"],
    grupoIdiomaRules: [(v) => !!v || "Selecciona una opción"],
    grupoNivelRules: [(v) => !!v || "Selecciona una opción"],
    grupoGrupoRules: [(v) => !!v || "Selecciona una opción"],

    // listados de roles para determinar uso de filtros
    locationFilterAllowedRoles: ["ROLE_SUPER_ADMIN"],
  }),

  created() {
    this.initialize();
  },

  computed: {
    ...mapGetters("App", {
      cursoActual: "GET_CURSO_ACTUAL",
      localizaciones: "GET_LOCALIZACIONES",
    }),

    ...mapGetters("Auth", {
      userRoles: "authRoles",
    }),

    localizacionesComputed() {
      return [{ id: 0, nombre: "Todos" }, ...this.localizaciones];
    },

    tiposComputed() {
      return this.tipos.map((tipo) => {
        return {
          id: tipo.id,
          nombre: tipo.nombre,
          disabled: this.disabledTipos.includes(tipo.id),
        };
      });
    },
  },

  watch: {
    cursoActual() {
      this.resetAll();
    },
  },

  methods: {
    async initialize() {
      await getAll().then((response) => {
        this.tipos = response.data;
      });

      if (!this.locationFilterAllowedRoles.includes(this.userRoles[0])) {
        this.localizacion = this.localizaciones.find(
          (loc) =>
            loc.nombre ===
            this.userRoles[0].split("ROLE_SUPER_ADMIN_")[1].substring(0, 1) +
            this.userRoles[0]
              .split("ROLE_SUPER_ADMIN_")[1]
              .substring(1)
              .toLowerCase()
        );

        this.localizaciones.forEach((loc) => console.log(loc.nombre));
        console.log(
          this.userRoles[0].split("ROLE_SUPER_ADMIN_")[1].substring(0, 1) +
          this.userRoles[0]
            .split("ROLE_SUPER_ADMIN_")[1]
            .substring(1)
            .toLowerCase()
        );

        console.log(this.localizacion);
      }
    },

    async onSubmit() {
      let filename;
      this.loading = true;

      this.queryOptions.curso = this.cursoActual.id;
      this.queryOptions.localizacion = this.localizacion.id;

      switch (this.tipo.id) {
        case 1:
          if (this.soloAlumnosNuevos) {
            filename = "listadoDeAlumnosNuevos";
            this.queryOptions.nuevo = this.soloAlumnosNuevos;
          } else {
            filename = "listadoDeAlumnos";
            if (typeof this.queryOptions.nuevo !== "undefined") {
              delete this.queryOptions.nuevo;
            }
          }
          break;
        case 2: // listado de grupos
          filename = "listadoDeGrupos";
          break;
        case 4: // listado aulas
          filename = "listadoDeAulas";
          break;
        case 5: // listado sorteo
          filename = "sorteo";
          this.queryOptions.orderBy = this.sorteoOrderOption;
          break;
        case 6: // listado carnets
          filename = "listadoCarnets";
          if (this.carnetsDe == "grupo") {
            delete this.queryOptions.curso;
            this.queryOptions.grupo = this.grupoGrupo.value.id;
          } else if (this.carnetsDe == "alumnos") {
            if (typeof this.queryOptions.grupo !== "undefined") {
              delete this.queryOptions.grupo;
            }
          }
          break;
        case 7: // Listado de alumnos de un grupo en concreto
          filename = "listadoDeAlumnosDeUnGrupo";
          this.queryOptions.nivel = this.grupoNivel.id;
          this.queryOptions.dia = this.grupoGrupo.value.dia.id;
          this.queryOptions.horario = this.grupoGrupo.value.horario.id;
          this.queryOptions.notas = this.grupoConNotas;
          break;
        case 8: // Listado de alumnos por grupos
          filename = "listadoDeAlumnosPorGrupos";
          this.queryOptions.notas = this.grupoConNotas;
          this.queryOptions.orderBy = this.grupoOrderOption;
          break;
        case 9: // Listado por edades
          filename = "listadoPorEdades";
          break;
        case 10:
          filename = "listadoAlumnoNuevosPorCurso"
          break;
        case 11:
          filename = "listadoAlumnoPorRemesa"
          this.queryOptions.remesa = this.remesa;
          break;
        case 12:
          filename = "listadoAlumnosPagoPorDomiciliacion";
          this.queryOptions.tipoPago = this.tipoPago;
          this.queryOptions.metodoPago = 2;
          break;
        case 13:
          filename = "listadoAlumnosPagoPorTarjeta";
          this.queryOptions.porWeb = this.porWeb;
          this.queryOptions.metodoPago = 1;
          break;
        case 14:
          filename = "listadoAlumnosPagoPorIngreso";
          this.queryOptions.metodoPago = 3;
          break;
      }

      await getListado(this.tipo, this.queryOptions).then(function (response) {
        let b64 = response.data.output;
        const link = document.createElement("a");

        if (b64.tipoArchivo.toLowerCase() === 'pdf') {
          // Insert a link that allows the user to download the PDF file
          link.href = "data:application/octet-stream;base64," + b64.data;
        }

        if (b64.tipoArchivo.toLowerCase() === 'csv') {
          // Decode base64 data and prepare it to download on CSV file
          const buffer = Buffer.from(b64.data, 'base64');
          const decodedData = buffer.toString('utf8');
          const universalBOM = "\ufeff";
          let csvContent = "data:text/csv;charset=utf-8," + universalBOM + decodedData;
          const data = encodeURI(csvContent);
          link.href = data;
        }

        link.download = `${filename}.${b64.tipoArchivo.toLowerCase()}`;
        link.click();
      });

      this.loading = false;
    },

    async onChange() {
      this.queryOptions = {};
      this.resetGrupoFilters();

      if (!this.localizacion || !this.tipo) {
        return;
      }

      if ([6, 7].includes(this.tipo.id)) {
        this.idiomas = [];
        this.allNiveles = [];
        this.allGrupos = [];

        await getByCurso(this.cursoActual.id, this.localizacion.id).then(
          (response) => (this.allGrupos = response.data)
        );

        if (this.localizacion.idiomas && this.localizacion.niveles) {
          this.idiomas = this.localizacion.idiomas.map(
            (idioma) => idioma.idioma
          );
          this.allNiveles = this.localizacion.niveles;

          return;
        }

        await getIdiomas().then((response) => (this.idiomas = response.data));
        await getAllNiveles().then(
          (response) => (this.allNiveles = response.data)
        );
      }
    },

    cargarNiveles() {
      this.loadingNiveles = true;
      this.grupoNiveles = [];
      this.grupoNivel = null;
      this.grupoGrupos = [];
      this.grupoGrupo = null;

      // no esta definido o está vacio.
      if (!this.grupoIdioma || typeof this.grupoIdioma === "undefined") {
        this.loadingNiveles = false;
        return;
      }

      // buscar el idioma seleccionado
      let idiomaSeleccionado = this.idiomas.find((idioma) => {
        return idioma.nombre.toLowerCase() == this.grupoIdioma.toLowerCase();
      });

      // no ha sido posible encontrar el idioma seleccionado
      if (typeof idiomaSeleccionado === "undefined") {
        this.loadingNiveles = false;
        return;
      }

      // devolver los niveles del idioma seleccionado
      this.grupoNiveles = Object.assign(
        [],
        this.filtrarNivelesPorIdioma(idiomaSeleccionado)
      );
      this.loadingNiveles = false;
      return;
    },

    cargarGrupos() {
      this.loadingGrupos = true;
      this.grupoGrupos = [];
      this.grupoGrupo = null;

      // no esta definido o está vacio.
      if (!this.grupoIdioma || typeof this.grupoIdioma === "undefined") {
        this.loadingGrupos = false;
        return;
      }

      // no esta definido o está vacio.
      if (!this.grupoNivel || typeof this.grupoNivel === "undefined") {
        this.loadingGrupos = false;
        return;
      }

      // buscar el idioma y el nivel seleccionados
      let idiomaSeleccionado = this.idiomas.find((idioma) => {
        return idioma.nombre.toLowerCase() == this.grupoIdioma.toLowerCase();
      });

      let nivelSeleccionado = this.grupoNiveles.find((nivel) => {
        return (
          nivel.descripcion.toLowerCase() ==
          this.grupoNivel.descripcion.toLowerCase()
        );
      });

      // no ha sido posible encontrar el idioma o el nivel seleccionados
      if (
        typeof idiomaSeleccionado === "undefined" ||
        typeof nivelSeleccionado === "undefined"
      ) {
        this.loadingGrupos = false;
        return;
      }

      // devolver los grupos del idioma y nivel seleccionados
      let gruposData = this.filtrarGruposPorIdiomaNivel(
        idiomaSeleccionado,
        nivelSeleccionado
      );

      gruposData.forEach((g) => {
        let item = {
          value: { ...g },
          text: `${g.dia.descripcion} - ${g.horario.descripcion}`,
        };
        this.grupoGrupos.push(item);
      });

      this.grupoGrupos = Object.assign([], this.grupoGrupos);
      this.loadingGrupos = false;

      return;
    },

    filtrarNivelesPorIdioma(idioma) {
      return this.allNiveles.filter((nivel) => {
        return nivel.idioma.id == idioma.id;
      });
    },

    filtrarGruposPorIdiomaNivel(idioma, nivel) {
      let filtered = this.allGrupos.filter((grupo) => {
        return grupo.nivel.id == nivel.id;
      });

      return filtered.reduce((acc, current) => {
        const x = acc.find(
          (item) =>
            item.nivel.id === current.nivel.id &&
            item.dia.id === current.dia.id &&
            item.horario.id === current.horario.id
        );
        if (!x) {
          return acc.concat([current]);
        } else {
          return acc;
        }
      }, []);
    },

    resetAll() {
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
      this.queryOptions = {};

      // reasignar valores por defecto
      this.sorteoOrderOption = "nombre";
      this.grupoConNotas = false;
      this.grupoOrderOption = "nivel";
      this.carnetsDe = "alumnos";
      this.soloAlumnosNuevos = false;
    },

    carnetsDeChange(value) {
      if (value == "alumnos") {
        this.resetGrupoFilters();
      }
    },

    resetGrupoFilters() {
      this.grupoIdioma = null;
      this.grupoNivel = null;
      this.grupoGrupo = null;
    },
  },
};
</script>
